import * as React from "react";
import { RouteType } from "./CoreApp";
import { compileRoutes } from "@workflows/runtime-web";
export interface CoreRouterContextShape {
  baseUrl: string;
  routes?: Record<string, any>;
}
export const CoreRouterContextContainer = React.createContext<CoreRouterContextShape>({
  baseUrl: "",
  routes: {}
});
export type CoreRouterContextProps = React.PropsWithChildren<{
  baseUrl: string;
  routes?: RouteType[];
}>;
export function CoreRouterContext({
  children,
  baseUrl,
  routes
}: CoreRouterContextProps): JSX.Element {
  const mappedRoutes = React.useMemo(() => routes?.reduce((acc: Record<string, (_: any) => string>, route: RouteType) => {
    acc[route.identifier] = _ => route.path;
    return acc;
  }, {}), [routes]);
  const compiledRoutes = React.useMemo(() => mappedRoutes && compileRoutes(mappedRoutes), [mappedRoutes]);
  return <CoreRouterContextContainer.Provider value={{
    baseUrl,
    routes: compiledRoutes
  }}>
      {children}
    </CoreRouterContextContainer.Provider>;
}